import type { City, SkyWebcam } from '../domain/index.ts';
import { ERMONT, ERMONT_SKY_WEBCAM } from './ermont.ts';

export { ERMONT };

/** Villes servies. Une seule en V0.1 : l'architecture n'impose pas plus. */
export const CITIES: Readonly<Record<string, City>> = { [ERMONT.slug]: ERMONT };

export const DEFAULT_CITY = ERMONT;

/** Webcam de ciel proche, par ville (facultative). */
export const SKY_WEBCAMS: Readonly<Partial<Record<string, SkyWebcam>>> = { [ERMONT.slug]: ERMONT_SKY_WEBCAM };

export function findCity(slug: string): City | undefined {
  return Object.hasOwn(CITIES, slug) ? CITIES[slug] : undefined;
}
